exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.chip--select-multi[data-v-0a10171e] {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-transform-origin: top left;\n  transform-origin: top left;\n  white-space: nowrap;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/components/search-selector/styles.scss"],"names":[],"mappings":";AAAA;EACE,gBAAe;EACf,iBAAgB;EAChB,wBAAuB;EACvB,mCAAkC;EAClC,2BAA0B;EAC1B,oBAAmB;CACpB","file":"styles.scss","sourcesContent":[".chip--select-multi {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-transform-origin: top left;\n  transform-origin: top left;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a10171e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/search-selector/styles.scss
// module id = yLnq
// module chunks = 0